import { Hanko } from '../Hanko'
import { type ReceiptData, receiptFields } from './receipt-data'

function ReceiptLamp() {
  return (
    <svg viewBox="0 0 120 120" className="receipt__lamp" aria-hidden="true">
      <line x1="60" y1="0" x2="60" y2="38" stroke="currentColor" strokeWidth="1.5" />
      <path d="M30 66 C30 48 44 38 60 38 C76 38 90 48 90 66 Z" fill="currentColor" />
      <circle cx="60" cy="72" r="8" fill="none" stroke="currentColor" strokeWidth="2" />
      {[0, 1, 2, 3, 4, 5, 6].map((i) => {
        const a = (Math.PI * (i + 1)) / 8
        return (
          <line
            key={i}
            x1={60 + Math.cos(a) * 18}
            y1={72 + Math.sin(a) * 18}
            x2={60 + Math.cos(a) * 30}
            y2={72 + Math.sin(a) * 30}
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        )
      })}
    </svg>
  )
}

/** 感熱紙のレシート（DOM 版）。LP の見本と /log/$id で使う */
export function ReceiptView({ data, tilt = 0 }: { data: ReceiptData; tilt?: number }) {
  const f = receiptFields(data)
  return (
    <article className="receipt" style={{ ['--tilt' as string]: `${tilt}deg` }} lang={data.locale}>
      <header className="receipt__head">
        <Hanko text="集中喫茶" size={52} className="receipt__kakuin" />
        <p className="receipt__shop">{f.shop}</p>
        <p className="receipt__tagline">{f.tagline}</p>
      </header>
      <hr className="receipt__rule" />
      <dl className="receipt__rows">
        {f.rows.map(([k, v]) => (
          <div key={k}>
            <dt>{k}</dt>
            <dd>{v}</dd>
          </div>
        ))}
      </dl>
      <hr className="receipt__rule" />
      <p className="receipt__item">
        <span>{f.item}</span>
        <span className="receipt__leader" aria-hidden="true" />
        <span>{f.itemValue}</span>
      </p>
      {f.note && (
        <>
          <hr className="receipt__rule" />
          <p className="receipt__label">{f.noteLabel}</p>
          <p className="receipt__note">{f.note}</p>
        </>
      )}
      <hr className="receipt__rule receipt__rule--double" />
      <p className="receipt__total">
        <span>{f.totalLabel}</span>
        <span>{f.total}</span>
        <span className="receipt__stamp" aria-hidden="true">
          {f.stamp}
        </span>
      </p>
      <ReceiptLamp />
      <p className="receipt__name">{f.name}</p>
      <p className="receipt__thanks">{f.thanks}</p>
      {f.footer && <p className="receipt__footer">{f.footer}</p>}
    </article>
  )
}
